/* eslint-disable max-len */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const CategoriesIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <rect x="3" y="3" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="3" y="9.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="3" y="16.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="9.75" y="3" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="9.75" y="9.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="9.75" y="16.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="16.5" y="3" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="16.5" y="9.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
            <rect x="16.5" y="16.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
        </SvgIcon>
    );
};

export default CategoriesIcon;
